import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, CommonTranslationModule, MasterDetailModule } from '@sdbn/common';
import { SecureKeyAdministrationComponent } from './component/secure-key-administration.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PipesModule } from '@sdbn/common-essential';


@NgModule({
  declarations: [SecureKeyAdministrationComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    MatCheckboxModule,
    PipesModule
  ]
})
export class SecureKeyAdministrationModule { }
